import React, { createContext, useContext } from 'react';

// Create a context to hold the React instance
const IconContext = createContext(null);

// Provider component that passes React to child components
export function IconProvider({ children }) {
  return (
    <IconContext.Provider value={React}>
      {children}
    </IconContext.Provider>
  );
}

// Helper hook to get React instance
export function useIconContext() {
  return useContext(IconContext);
}